/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ready_To_Make_Your_First_SaleInputs */

const en_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to make your first sale?`)
};

const es_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para hacer tu primera venta?`)
};

const fr_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à réaliser votre première vente ?`)
};

const de_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit für deinen ersten Verkauf?`)
};

const ja_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の売上を作る準備はできましたか？`)
};

const zh_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好达成您的第一笔交易了吗？`)
};

const ar_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل أنت مستعد لتحقيق أول مبيعاتك؟`)
};

const id_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap melakukan penjualan pertama Anda?`)
};

const it_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto a fare la tua prima vendita?`)
};

const ru_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовы сделать свою первую продажу?`)
};

const pt_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto para fazer sua primeira venda?`)
};

const ko_ready_to_make_your_first_sale = /** @type {(inputs: Ready_To_Make_Your_First_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 판매를 시작할 준비가 되셨나요?`)
};

/**
* | output |
* | --- |
* | "Ready to make your first sale?" |
*
* @param {Ready_To_Make_Your_First_SaleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ready_to_make_your_first_sale = /** @type {((inputs?: Ready_To_Make_Your_First_SaleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ready_To_Make_Your_First_SaleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ready_to_make_your_first_sale(inputs)
	if (locale === "es") return es_ready_to_make_your_first_sale(inputs)
	if (locale === "fr") return fr_ready_to_make_your_first_sale(inputs)
	if (locale === "de") return de_ready_to_make_your_first_sale(inputs)
	if (locale === "ja") return ja_ready_to_make_your_first_sale(inputs)
	if (locale === "zh") return zh_ready_to_make_your_first_sale(inputs)
	if (locale === "ar") return ar_ready_to_make_your_first_sale(inputs)
	if (locale === "id") return id_ready_to_make_your_first_sale(inputs)
	if (locale === "it") return it_ready_to_make_your_first_sale(inputs)
	if (locale === "ru") return ru_ready_to_make_your_first_sale(inputs)
	if (locale === "pt") return pt_ready_to_make_your_first_sale(inputs)
	return ko_ready_to_make_your_first_sale(inputs)
});